<template>
  <div class="c-side f-Cal-Reg" :class="{'isHide': isHide, 'isBottom': isBottom}">
    <div class="c-side__wrap">
      <dl v-if="note.links">
        <!-- dt v-html="note.links.title"></dt -->
        <dd><a href="#top" @click="onAnchor">00.<br>{{likeNames[0]}}</a></dd>
        <dd><a href="#feature1" @click="onAnchor">01.<br>{{likeNames[1]}}</a></dd>
        <dd><a href="#feature2" @click="onAnchor">02.<br>{{likeNames[2]}}</a></dd>
        <dd><a href="#feature3" @click="onAnchor">03.<br>{{likeNames[3]}}</a></dd>
        <dd><a href="#feature4" @click="onAnchor">04.<br>{{likeNames[4]}}</a></dd>
        <dd><a href="#feature5" @click="onAnchor">05.<br>{{likeNames[5]}}</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
  import { breakpoint } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    props: ['page'],
    data() {
      return {
        lang: '',
        note: {},
        ispc: false,
        footerHeight: 192,
        isHide: true,
        kvHeight: 0,
        isBottom: false,
        likeNames: [
          '',
          '',
          '',
          '',
          ''
        ]
      }
    },
    store,
    created() {

    },
    mounted() {
      this.lang = this.$store.getters.getLang;
      this.note = this.$store.getters.getNote;

      if (this.page === 'benefit') {
        if (this.lang === "zh-cmn-Hans") {
          this.likeNames[0] = '首页';
          this.likeNames[1] = '优点';
          this.likeNames[2] = '优点';
          this.likeNames[3] = '优点';
          this.likeNames[4] = '优点';
          this.likeNames[5] = '优点';
        } else if (this.lang === "zh-cmn-Hant") {
          this.likeNames[0] = 'TOP PAGE';
          this.likeNames[1] = 'BENEFIT';
          this.likeNames[2] = 'BENEFIT';
          this.likeNames[3] = 'BENEFIT';
          this.likeNames[4] = 'BENEFIT';
          this.likeNames[5] = 'BENEFIT';
        } else {
          this.likeNames[0] = 'TOP PAGE';
          this.likeNames[1] = 'BENEFIT';
          this.likeNames[2] = 'BENEFIT';
          this.likeNames[3] = 'BENEFIT';
          this.likeNames[4] = 'BENEFIT';
          this.likeNames[5] = 'BENEFIT';
        }
      } else {
        if (this.lang === "zh-cmn-Hans") {
          this.likeNames[0] = '首页';
          this.likeNames[1] = '工艺';
          this.likeNames[2] = '工艺';
          this.likeNames[3] = '工艺';
          this.likeNames[4] = '工艺';
          this.likeNames[5] = '工艺';
        } else if (this.lang === "zh-cmn-Hant") {
          this.likeNames[0] = 'TOP PAGE';
          this.likeNames[1] = 'TECHNOROGY';
          this.likeNames[2] = 'TECHNOROGY';
          this.likeNames[3] = 'TECHNOROGY';
          this.likeNames[4] = 'TECHNOROGY';
          this.likeNames[5] = 'TECHNOROGY';
        } else {
          this.likeNames[0] = 'TOP PAGE';
          this.likeNames[1] = 'TECHNOROGY';
          this.likeNames[2] = 'TECHNOROGY';
          this.likeNames[3] = 'TECHNOROGY';
          this.likeNames[4] = 'TECHNOROGY';
          this.likeNames[5] = 'TECHNOROGY';
        }
      }
    },
    methods: {
      start() {
        this.resize();
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.scroll);
      },
      onAnchor(e) {
        this.$_onAnchor(e);
      },
      resize() {
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
        } else {
          this.ispc = false;
        }

        //const rectKv = document.getElementById('c-mv').getBoundingClientRect();
        //this.kvHeight = (rectKv.height * 0.5);
        this.kvHeight = window.innerHeight * 0.6;

        this.scroll();
      },
      scroll() {
        if (this.ispc) {
          if (this.kvHeight < this.currentScrollY()) {
            this.isHide = false;
          } else {
            this.isHide = true;
          }

          //console.log(this.getScrollBottom());
          if (this.getScrollBottom() > this.footerHeight) {
            // fixed
            this.isBottom = false;
          } else {
            // absolute
            this.isBottom = true;
          }
        }
      },
      currentScrollY() {
        return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      },
      getScrollBottom() {
        var body = window.document.body;
        var html = window.document.documentElement;
        var scrollTop = body.scrollTop || html.scrollTop;
        return html.scrollHeight - html.clientHeight - scrollTop;
      }
    }
  }
</script>
